import classnames from 'classnames';
import { ThemeOptions } from '../publicSession/types';
export function getGlobalClassnamesForContext(_a) {
    var isMobile = _a.isMobile, theme = _a.theme, isSisu = _a.isSisu, _b = _a.flags, flags = _b === void 0 ? {} : _b, themeSkin = _a.themeSkin;
    return classnames(isMobile && 'mobile', !isSisu && "theme-" + (theme || ThemeOptions.DARK).toString(), isSisu && 'sisu', flags['devious_sans'] && 'devious-sans', flags['stats'] && 'with-stats-feature', themeSkin && themeSkin);
}
export function getForcedGlobalClassnamesForContext(_a) {
    var theme = _a.theme;
    return "theme-" + theme + " forced-theme-" + theme;
}
//# sourceMappingURL=helpers.js.map